@if (!isLoaded) {
<lin-spinner></lin-spinner>
} @if (formError) {
<div class="lin-form-error">{{ formError }}</div>
} @if (isLoaded) {
<form lin-layout-form [formGroup]="userForm" (ngSubmit)="handleUpdateUser()">
  <lin-layout-form-sections-wrapper>
    <lin-layout-form-section layout="triple">
      <lin-form-label required>{{ 'RESELLER.USERS.EMAIL' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="email" />
        <mat-error>
          <lin-form-field-error [control]="userForm.get('email')" controlName="email"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'RESELLER.USERS.NAME' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="name" />
        <mat-error>
          <lin-form-field-error [control]="userForm.get('name')" controlName="name"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'RESELLER.USERS.SURNAME' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="surname" />
        <mat-error>
          <lin-form-field-error [control]="userForm.get('surname')" controlName="surname"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <lin-form-label required>{{ 'RESELLER.USERS.PHONE_NUMBER' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="phoneNumber" autocomplete="off" placeholder="{{ 'PLACEHOLDERS.PHONE_NUMBER' | translate }}" />
        <mat-error>
          <lin-form-field-error [control]="userForm.get('phoneNumber')" controlName="phoneNumber"></lin-form-field-error>
        </mat-error>
      </mat-form-field>
    </lin-layout-form-section>

    <lin-layout-form-section layout="triple">
      <lin-form-label required>{{ 'RESELLER.USERS.ROLE' | translate }}:</lin-form-label>
      <mat-form-field>
        <mat-select formControlName="role" [disabled]="currentUserId === user?.id">
          @for (role of roles; track role.id) {
          <mat-option [value]="role.id">{{ role.displayName }}</mat-option>
          }
        </mat-select>
        <mat-error>
          <lin-form-field-error [control]="userForm.get('role')" controlName="role"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      @if (resellerUser) {
      <lin-form-label>{{ 'RESELLER.USERS.STATUS' | translate }}:</lin-form-label>
      <mat-form-field>
        <input matInput formControlName="status" [value]="userForm.controls.status?.value | titlecase" />
        <mat-error>
          <lin-form-field-error [control]="userForm.get('status')" controlName="status"></lin-form-field-error>
        </mat-error>
      </mat-form-field>

      <label>{{ 'RESELLER.USERS.BLOCKING_STATUS' | translate }}:</label>
      <mat-checkbox
        class="blocking-status"
        aria-label="{{ 'RESELLER.USERS.BLOCKING_STATUS' | translate }}"
        formControlName="blockingStatus"
      >
        {{ 'RESELLER.USERS.USER_BLOCKED' | translate }}
      </mat-checkbox>

      @if (userForm.get('blockingStatus').value) {
      <label>{{ 'RESELLER.USERS.BLOCKING_MESSAGE' | translate }}:</label>
      <mat-form-field>
        <input matInput formControlName="blockingMessage" />
        <mat-error>
          <lin-form-field-error [control]="userForm.get('blockingMessage')" controlName="blockingMessage"></lin-form-field-error>
        </mat-error>
      </mat-form-field>
      } }
      <lin-language-field formControlName="language"></lin-language-field>
    </lin-layout-form-section>
  </lin-layout-form-sections-wrapper>

  <lin-layout-form-toolbar>
    <div fxLayout="row">
      <lin-form-submit-button class="toolbar-button" [isLoading]="isSubmitting" data-testid="btn-save">
        {{ 'BUTTONS.SAVE' | translate }}
      </lin-form-submit-button>
      @if (resellerUser) {
      <button
        mat-raised-button
        class="toolbar-button"
        color="accent"
        type="button"
        [disabled]="isSSOUser"
        (click)="resetPassword()"
        data-testid="btn-reset-password"
      >
        {{ 'RESELLER.USERS.RESET_PASSWORD' | translate }}
      </button>
      }
    </div>

    @if (resellerUser) {
    <lin-layout-form-toolbar-info>
      <lin-layout-form-toolbar-info-row>
        <lin-layout-form-toolbar-info-label>{{ 'RESELLER.USERS.CREATED' | translate }}: </lin-layout-form-toolbar-info-label>
        <lin-layout-form-toolbar-info-value>
          {{ (resellerUser.createdAt | dayjsDateTime) || '-' }} {{ resellerUser.createdByName && 'RESELLER.USERS.BY' | translate }} {{
          resellerUser.createdByName }}
        </lin-layout-form-toolbar-info-value>
      </lin-layout-form-toolbar-info-row>

      <lin-layout-form-toolbar-info-row>
        <lin-layout-form-toolbar-info-label>{{ 'RESELLER.USERS.UPDATED' | translate }}: </lin-layout-form-toolbar-info-label>
        <lin-layout-form-toolbar-info-value>
          {{ (resellerUser.updatedAt | dayjsDateTime) || '-' }} {{ resellerUser.updatedBy && 'RESELLER.USERS.BY' | translate }} {{
          resellerUser.updatedBy?.fullName }}
        </lin-layout-form-toolbar-info-value>
      </lin-layout-form-toolbar-info-row>

      <lin-layout-form-toolbar-info-row>
        <lin-layout-form-toolbar-info-label> {{ 'RESELLER.USERS.LAST_LOGIN_DATE' | translate }}: </lin-layout-form-toolbar-info-label>
        <lin-layout-form-toolbar-info-value> {{ (resellerUser.lastLoggedAt | dayjsDateTime) || '-' }} </lin-layout-form-toolbar-info-value>
      </lin-layout-form-toolbar-info-row>
    </lin-layout-form-toolbar-info>
    }
  </lin-layout-form-toolbar>
</form>
}
